import { Button } from 'application/presentation/common/uiComponents'

import s from './PaymentFail.module.scss'

type Props = {
  message: string
  onBackPress: () => void
}

export const PaymentFail = ({ message, onBackPress }: Props) => {
  return (
    <div className={s.container}>
      <div>Произошла ошибка</div>
      <div>{message}</div>
      <Button type="button" onClick={onBackPress}>
        Назад
      </Button>
    </div>
  )
}
